import React from 'react'
import Contact from '../../components/Navbar/Contact'

function ContactPage() {
  return (
    <Contact/>
  )
}

export default ContactPage